import { FC } from "react";
import { IconPropsType } from ".";

export const Reports: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.25"
        y="15.75"
        width="14.5"
        height="11.5"
        rx="1.75"
        transform="rotate(-90 1.25 15.75)"
        stroke="#555555"
        strokeWidth="1.5"
      />
      <rect x="4" y="3.5" width="6" height="2" rx="1" fill="#555555" />
      <rect x="4" y="7.5" width="6" height="2" rx="1" fill="#555555" />
      <rect x="4" y="11.5" width="4" height="2" rx="1" fill="#555555" />
    </svg>
  );
};
